<div class="nav" [ngClass]="{'horizontal':layout === 'horizontal', 'vertical':layout === 'vertical'}">

    <!-- Vertical Navigation Layout -->
    <ng-container *ngIf="layout === 'vertical'">

        <ng-container *ngFor="let item of navigation">
            
            <fuzz-nav-vertical-group *ngIf="item.type=='group'" [item]="item"></fuzz-nav-vertical-group>
            <fuzz-nav-vertical-collapsable *ngIf="item.type=='collapsable'" [item]="item"></fuzz-nav-vertical-collapsable>
            <fuzz-nav-vertical-item *ngIf="item.type=='item'" [item]="item"></fuzz-nav-vertical-item>

        </ng-container>

    </ng-container>
    <!-- / Vertical Navigation Layout -->

    <!-- Horizontal Navigation Layout -->
    <ng-container *ngIf="layout === 'horizontal'">

        <ng-container *ngFor="let item of navigation">
            <fuzz-nav-horizontal-collapsable *ngIf="item.type=='group'" [item]="item"></fuzz-nav-horizontal-collapsable>
            <fuzz-nav-horizontal-collapsable *ngIf="item.type=='collapsable'" [item]="item"></fuzz-nav-horizontal-collapsable>
            <fuzz-nav-horizontal-item *ngIf="item.type=='item'" [item]="item"></fuzz-nav-horizontal-item>
        </ng-container>

    </ng-container>
    <!-- / Horizontal Navigation Layout -->

</div>
